enum HttpMethods {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
}

export default HttpMethods;
